import i18next from 'i18next';
import moment from 'moment-timezone';
import React from 'react';

import { InpulseLabel } from '@commons/DeepsightComponents';
import DisplayNumber from '@commons/DisplayNumber';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import { formatTimeWithLanguageCode } from '@commons/utils/date';
import { labelContainerStyle, labelInAdvancedFilterStyle } from '@commons/constants/labelStyle';
import { SentAtContainer } from '@stocks/StocksInventories/StocksInventoriesTransfer/styledComponents';

import { transferStatusColorCodes, transferStatusLegend } from './constants';

const getColorValue = (id, array, field) => {
  let res = array.find((elem) => elem.id === id);

  if (res) {
    return res[field];
  }
};

export const renderLabel = (label, key, colorCodes) => (
  <div className="supplier-label-render" style={labelContainerStyle}>
    <InpulseLabel
      color={getColorValue(key, colorCodes, 'inpulseColor')}
      text={label}
      type={'tertiary'}
    />
  </div>
);

const _getStatusColumn = () => ({
  id: 'status',
  name: i18next.t('STOCKS.TRANSFERS.SENDING_STATUS'),
  propertyKey: 'status',
  filterType: 'string',
  // Used to render advanced status filter list
  list: Object.keys(transferStatusLegend).reduce((result, key) => {
    result.push({
      id: key,
      status: key,
      itemValue: key,
      name: i18next.t(transferStatusLegend[key].name),
      renderValue: () => (
        <div className="supplier-label-render">
          <InpulseLabel
            color={getColorValue(key, transferStatusColorCodes, 'inpulseColor')}
            style={labelInAdvancedFilterStyle}
            text={i18next.t(transferStatusLegend[key].name)}
            type={'tertiary'}
          />
        </div>
      ),
    });

    return result;
  }, []),
  // Used to render status column et in list view
  render: (status, item) =>
    renderLabel(
      i18next.t(transferStatusLegend[status].name),
      item.status,
      transferStatusColorCodes,
    ),
});

export const getColumns = ({ storeName, hasTransferDeliveryTime, userLanguageCode }) => {
  const columns = [
    {
      id: 'senderStoreName',
      name: i18next.t('STOCKS.TRANSFERS.SENDER_STORE', {
        storeName,
      }),
      propertyKey: 'senderStoreName',
      render: (it) => <div>{it}</div>,
    },
    {
      id: 'recipientStoreName',
      name: i18next.t('STOCKS.TRANSFERS.RECIPIENT_STORE', {
        storeName,
      }),
      propertyKey: 'recipientStoreName',
      render: (it) => <div>{it}</div>,
    },
    {
      id: 'sentAt',
      name: i18next.t('STOCKS.TRANSFERS.SENDING_DATE'),
      propertyKey: 'sentAt',
      render: (it, element) => (
        <SentAtContainer>
          {moment
            .tz(it, element.senderStore.timezone)
            .format(DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR)}
        </SentAtContainer>
      ),
      excludeFromSearch: true,
      filterType: 'date',
    },
  ];

  if (hasTransferDeliveryTime) {
    columns.push({
      id: 'deliveryTime',
      name: i18next.t('STOCKS.TRANSFERS.DELIVERY_TIME'),
      tooltipText: i18next.t('STOCKS.TRANSFERS.DELIVERY_TIME_TOOLTIP'),
      propertyKey: 'deliveryTime',
      render: (it) => {
        if (it == null) {
          return '-';
        }

        return (
          <SentAtContainer>{formatTimeWithLanguageCode(it, userLanguageCode)}</SentAtContainer>
        );
      },
      excludeFromSearch: true,
      filterType: 'date',
    });
  }

  columns.push(
    _getStatusColumn(),
    {
      id: 'totalPrice',
      name: i18next.t('STOCKS.TRANSFERS.TOTAL_EXCLUDING_TAXES'),
      propertyKey: 'totalPrice',
      render: (item) => <DisplayNumber displayCurrencyCode={true} number={item} />,
      excludeFromSearch: true,
      filterType: 'numeric',
    },
    // Hidden column for reference to enable search by reference
    {
      id: 'reference',
      name: 'reference',
      propertyKey: 'reference',
      render: () => {},
      hidden: true,
    },
  );

  return columns;
};
